export const initialValues: { [key: string]: { [key: string]: any } } = {
  unitNumber: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  tenantName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  tenantType: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  currentRent: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  willIncreaseRent: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  newRent: {
    value: undefined,
    error: '',
    isTouched: false,
    isDependent: {
      fieldName: 'willIncreaseRent',
      dependentValue: 'yes',
      rules: {
        type: 'number',
        required: true,
        min: 0,
      },
    },
    rules: {
      type: 'number',
      required: false,
    },
  },
};

export const tenantTypes = ['Retail', 'Office', 'Residential'];
